import { Component, OnInit } from '@angular/core';
import { Helper } from '../../Helper';
import { BottomSheetOverviewExampleSheet } from '../../tabs/tabs.component';
import { MatDialog, MatBottomSheet } from '@angular/material';

@Component({
  selector: 'app-sent-messages',
  templateUrl: './sent.component.html',
  styleUrls: ['./sent.component.css','../../sub-admin/subadmin.component.css','../../../assets/bootstrap.css']
})
export class SentMessagesComponent implements OnInit {

  displayedColumnsOffices: string[] = ['user', 'subject',"description","date","action"];

  dataOffices=[

  ];
  showView=false;
  viewElement={};
  search=""
  timer=null
  data:any={}
  page=1
  per_page=25;
  constructor(public Helper:Helper,
    public dialog:MatDialog,
    private _bottomSheet: MatBottomSheet) { }

  ngOnInit() {
    this.getdata()
  }
  searchData(e){
      
    if(this.search=="")  return 1;  
    
    if(this.timer)
      clearTimeout(this.timer);

    this.timer=setTimeout(()=>{
       this.page=1;
       this.getdata()
    },500)
    
  }
  searching=true;
  getdata(){
    this.searching=true;

    this.Helper.makeRequest("admin/sent-messages?page="+this.page+"&search="+this.search,{},"get",{toast:false}).subscribe(d=>{
      console.log(d.data,"d.data")
      this.dataOffices= d.data.data;
      this.data= d.data;
      this.searching=false;
    })
  }
  prev(){
    this.page=this.page-1;
    this.getdata();
  }
  next(){
    this.page=this.page+1;
    this.getdata();
  } 
  view(el){
    this.showView=true;
    this.viewElement=el.slug;
  }
  onBack(){
   
    this.showView=false;
  }
  delete(el){
    let sheet=this._bottomSheet.open(BottomSheetOverviewExampleSheet,{ ariaLabel: 'Are you sure you want to delete this experience'});
    sheet.afterDismissed().subscribe((data) => {
      if(data){
        this.Helper.makeRequest("admin/delete-message/"+el.slug,{id:el.slug},"delete").subscribe(d=>{
          this.getdata();
             
        })
      }
       
    });
   
  }
  
}
